import { jsx as _jsx } from "react/jsx-runtime";
import './Chevron.scss';
export const Chevron = ({ className, direction = "up" }) => {
    return (_jsx("svg", { className: `chevron ${direction}`, width: "11", height: "18", viewBox: "0 0 11 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1 1L9 8.99956L1 17", strokeWidth: "2", strokeLinecap: "round" }) }));
};
